export default __webpack_public_path__ + "static/media/wika_ellipse.4e072b3c.png";